// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__33xdH","sk-bounce-delay":"Spinner_sk-bounce-delay__2rwhQ","bounce-1":"Spinner_bounce-1__2hp0_","bounce-2":"Spinner_bounce-2__3t8ZA"};